// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05c11506","455":"6b426109","977":"8f5d7b74"}[chunkId] + ".chunk.js";
};